import React, { useState, useRef,useCallback } from 'react';
import { debounce } from 'lodash';
import { FormControl } from 'react-bootstrap';

const DebouncedFilter = React.memo(({ onFilter,value }) => {
  const [searchTerm, setSearchTerm] = useState(value);
  const didMountRef = useRef(false);

  const handleInputChange = (event) => {
    const { value } = event.target;
    setSearchTerm(value);
  };

  const debouncedFilter = useCallback(debounce(onFilter, 500), [onFilter]);
  
  React.useEffect(() => {
    setSearchTerm(value)
  },[value]);


  React.useEffect(() => {
    if (didMountRef.current) {
      // do something on state change here
      debouncedFilter(searchTerm);
    } else {
      didMountRef.current = true;
    }
    return () => {
      debouncedFilter.cancel();
    };
  }, [searchTerm]);

  return (
    <FormControl
      type="text"
      placeholder=""
      value={searchTerm}
      onChange={handleInputChange}
      onBlur={() => {
        if (searchTerm === '') {
          onFilter('');
        }
      }}
    />
  );
});

export default DebouncedFilter;